import Phaser from "phaser"

import { cScene } from "../cScene";
import { ScreenItem, ScreenObject } from "../dataTypes";
import { Base, ModuleCollection } from "../cGameObjects/modules";
import { cDisplay } from "../cDisplay";
import { net } from "../utils/net";
import { actionEvaluation } from "../actionEvaluation";
import { cSprite } from "../cGameObjects/cSprite";
import { cText } from "../cGameObjects/cText";
import { cGame } from "../cGame";

export const maxScorePerGame = 4;
export const maxGames = 7;
export const maxStartQuiz = 12;
export const maxCoins = (maxScorePerGame * maxGames) + maxStartQuiz

export const addCoinAnimation = (sc:cScene) => {

  var animcfg = {
    key: 'coin_drop',
    frameRate: 12,
    repeat: 0,
    frames:[
      {key: 'quiz_coins', frame:'coins0000.png'},
      {key: 'quiz_coins', frame:'coins0001.png'},
      {key: 'quiz_coins', frame:'coins0002.png'},
      {key: 'quiz_coins', frame:'coins0003.png'},
      {key: 'quiz_coins', frame:'coins0004.png'},
      {key: 'quiz_coins', frame:'coins0005.png'},
      {key: 'quiz_coins', frame:'coins0006.png'},
    ]
  }
  sc.anims.create(animcfg);

}



export class EvaluationCard extends Phaser.GameObjects.Container {

  public readonly isContainer: boolean = true;
  public modules: ModuleCollection;

  private sData!: ScreenObject;  
  private disp!: cDisplay;
  private actionEval!: actionEvaluation;
  private coinHolder!: Phaser.GameObjects.Container;
  private basePath: String = '';

  private panelWidth: number = 1248;
  private panelHeight: number = 595;

  private coins!: number ;


  constructor(sc:cScene, data: ScreenItem){
    super(sc,undefined,);    
    this.modules = Base.initModules(this,data);

    if (data && data.asset){
      this.basePath = net.gamedataFolder + data.asset;
      net.fetchJson( this.basePath + '/screen.json',{},(data:ScreenObject)=>{  
        this.sData = data;
        this.buildScreen();
      });      
    }

    addCoinAnimation(sc);

  }

  buildScreen(){
    this.disp = new cDisplay(this.scene, this.sData.screen,()=>{
    });

    if(this.sData.actions){
      this.actionEval = new actionEvaluation(this.scene as cScene,this.sData.actions)
      this.actionEval.container = this.disp
    }

    this.disp.events.addListener('action',(action:string, el:any, data:ScreenItem)=>{
      (this.scene as cScene).triggerSceneEvent('close_evaluation');
    });

    this.add(this.disp);
    this.disp.x = -this.panelWidth / 2;
    this.disp.y = -this.panelHeight / 2;

    var sl = this.disp.getByName('law_image')
    sl.basePath = this.basePath + '/';

    this.coinHolder = this.disp.getByName('coin_holder');
    
  }

  createCoins(coins:number){
    for (var a=0; a < coins; a++){
      this.coinHolder.add( new Phaser.GameObjects.Sprite(this.scene,0,0-(a*10),'quiz_coins','coins0006.png')  )          
    }
  }

  public set image( v:string ){
  }

  public set text( v: string){
  }


  public set score( v:string ){
    var [name,score,total] = v.split(':');    
    var scores = cGame.current.state.get('scoring',{});
    var curScore = Math.round( (Number(score) / Number(total)) * maxScorePerGame);

    if (curScore===0 && Number(score) > 0) curScore = 0;

    //scores[name] = scores[name] ? Math.max(curScore,scores[name]) : curScore;
    scores[name] = curScore;
    
    console.log('CURRENT SCORE', score,total, scores[name],scores);

    var globalScore:number = 0;
    Object.keys(scores).map( (k)=>{ 
      globalScore += (k===name) ? 0 : scores[k]; 
      return null 
    });

    this.coinHolder.removeAll();
    this.coins = globalScore;
    this.createCoins(globalScore);

    setTimeout(()=>{
      this.addCoinDisplay( scores[name] );
    },2000)
    

    var ref:cSprite = this.disp.getByName('DATA') as cSprite
    var DATA = ref.modules.data._extraData
    
    if (DATA && DATA[name]){
      this.disp.getByName('law_text').textdata = DATA[name].info
      this.disp.getByName('law_text').styledata = {color:DATA[name].textcolor}
      this.disp.getByName('law_header').textdata = DATA[name].right
      this.disp.getByName('law_image').asset = DATA[name].image

      var txt = curScore < 2 ? DATA[name].score_bad : DATA[name].score;
      txt = txt.replace('[score]',score).replace('[total]',total);
      this.disp.getByName('result_title').textdata = txt;

      var scoreText:cText = this.disp.getByName('result_info_register')
      scoreText.textdata =  scoreText.modules.data._extraData.text.replace('[score]',globalScore+scores[name]).replace('[total]',maxCoins)
    }


    cGame.current.state.set('scoring', scores);
  }


  private addCoinDisplay(v: number){
    var coins = this.coins + (v-1);
    var dd = setInterval( ()=>{
      if (this.coins <= coins){
        this.appendCoin();
        this.coins++;
      }else{
        clearInterval(dd);
      }
    },300)

  } 

  appendCoin(){
    if (!this.scene) return
    var yy: number = this.coins * 10;
    var xx: number = 0;

    try {
      var sp: Phaser.GameObjects.Sprite = new Phaser.GameObjects.Sprite(this.scene,xx,0-yy,'quiz_coins');
      sp.play('coin_drop')
      sp.depth = 999
      this.scene.add.existing(sp);
      var tg: Phaser.GameObjects.Container = this.disp.getByName('coin_holder') as Phaser.GameObjects.Container;
      tg.add(sp);  
    } catch (e){
      console.warn('unable to add coins')
    }

  }


  public set pop(v:string){
    if (isNaN(v as any)) console.warn('EVALUATION Pop got Number needs string (=)')
    console.log('POP',v)
    if (v === '-1'){
      this.scene.tweens.add({
        duration: 600,
        targets: this,
        scaleX: 0.4,
        scaleY: 0.4,
        alpha: 0,
        y: 1080,
        ease:Phaser.Math.Easing.Back.In,
        completed: () => {
          console.log('COMPL')
          //this.visible = false
        },        
      })
      return
    }

    this.score = v


    const animOptions: any = {
      duration: 600,
      targets: this,
      scaleX:1,
      scaleY:1,
      alpha:1,
      y: 560,
      ease: Phaser.Math.Easing.Back.Out,
      completed: () => {
        setTimeout(() => {
        }, 800)
      },
      start:()=>{
        this.visible = true
        console.log('phgp')
      }
    }

    this.scaleX = 0.4
    this.scaleY = 0.4
    this.y = 1080
    this.scene.tweens.add(animOptions)
  }

}